import './assets/styles/core.css'
import './assets/tenants/emiratai/styles/base.css'
import './assets/tenants/emiratai/styles/dark/vars.css'
import './assets/styles/ant-design-overrides.css'

import { createApp, defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'
import Antd, { TypographyLink, TypographyText, TypographyTitle } from 'ant-design-vue'
// import App from './App.vue'
import router from './router'
import 'ant-design-vue/dist/reset.css'

const app = createApp(defineAsyncComponent(() => import('./App.vue')))

app.use(createPinia())
app.use(router)
app.use(Antd)

app.component('a-title', TypographyTitle)
app.component('a-text', TypographyText)
app.component('a-link', TypographyLink)

app.mount('#app')
